import styled from 'styled-components';
import { device } from '../../../styles/devices';

export const PartnerDealerWrapper = styled.div`
  font-family: Audi Type;
  padding: 24px;
`;
export const FilterTypeName = styled.div`
  line-height: 24px;
  font-size: 16px;
  letter-spacing: 0.003px;
`;
export const ListOfDealers = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  padding-top: 16px;
`;
